import React, {useEffect, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'

import Box from '../component/Box/Box'
import BreadcrumbItem from '../component/BreadcrumbItem/BreadcrumbItem'
import FormButtons from '../component/Form/FormButtons'
import Loading from '../component/Loading/Loading'
import Page from '../component/Page/Page'
import Notify from '../services/Notify'
import ReadpointService from '../services/ReadpointService'
import ReadpointUsersAccessSelect from './component/ReadpointUserAccessSelect'

export default function ReadpointUsersAccessPage({ match, history }) {

  const [userIds, setUserIds] = useState(null)
  const [readpoint, setReadpoint] = useState(null)

  const readpointService = new ReadpointService()

  const doRequest = async (e) => {
    e.preventDefault()
    try {
      await readpointService.assocUsersInReadpoint(match.params.readpointId, userIds)
      Notify.success('Sucesso ao salvar ')
    } catch (error) {
      Notify.error('Erro ao atualizar ')
    } finally {
      history.goBack()
    }
  }

  useEffect(() => {
    async function getReadPoint() {
      try {
        setReadpoint(await readpointService.findById(match.params.readpointId))
      } catch (error) {
        Notify.error('Erro ao recuperar nome do ponto de leitura', error)
      }
    }
    getReadPoint()
  }, [])

  useEffect(() => {
    if (!readpoint) return
    setUserIds(readpoint.usersIds)
  }, [readpoint])

  return (
    !readpoint ? <Loading /> :
      <Page title={`Usuários com acesso ao portal - ${readpoint.friendlyName}`} breadcrumbs={[<BreadcrumbItem title="Lista de ponto de leituras" to="/list/readpoints" />]}>
        <Box>
          <Form onSubmit={doRequest}>
            <Row className="mb-4">
              <Col md={4}>
                <ReadpointUsersAccessSelect selectedUsers={userIds || []} updateUsers={setUserIds} />
              </Col>
            </Row>
            <FormButtons history={history}/>
          </Form>
        </Box>
      </Page>
  )
}



// WEBPACK FOOTER //
// ./src/readpoint/ReadpointUsersAccessPage.js